// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extract-data-modal{
    width: 1000px;
    max-width: 100%;
    height: 90vh;
    overflow-y: scroll;
    background-color: white;
    border-radius: 12px;
    z-index: 1000;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50% , -50%);
    border: none;
    
    
}

.extract-data-modal .extract-head{
    padding: 20px 17px;
    display: flex;
    /* align-items: center; */
    justify-content: space-between;
}

.extract-data-modal .extract-head .xclose-btn{
    background-color: transparent;
    width: 35px;
    height: 35px;
    border-radius: 50%;
    border: none;
    cursor: pointer;
    transition: var(--main-transition);
}

.extract-data-modal .extract-head .xclose-btn:hover{
    background-color: #EEE;
}

.extract-data-modal .extract-head .xclose-btn svg{
    color: var(--gray-color);
    font-size: 18px;
}


.extract-data-modal .table{
    background-color: white;
    padding: 10px;

}

.extract-data-modal .table .row-head{
    background-color: white;
    border: 1px solid #EEE;
    height: 40px;
    border-radius: 8px;
    display: flex;
    justify-content: space-around;
}

.extract-data-modal .table .row{
    background-color: white;
    border: 1px solid #EEE;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-top: 5px;
    height: 45px;
}

.extract-data-modal .table .table-body{
    margin-top: 8px;
    
}`, "",{"version":3,"sources":["webpack://./src/Components/Utils/ExtractModal.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,YAAY;;;AAGhB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;;AAGA;IACI,uBAAuB;IACvB,aAAa;;AAEjB;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;;AAEnB","sourcesContent":[".extract-data-modal{\n    width: 1000px;\n    max-width: 100%;\n    height: 90vh;\n    overflow-y: scroll;\n    background-color: white;\n    border-radius: 12px;\n    z-index: 1000;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50% , -50%);\n    border: none;\n    \n    \n}\n\n.extract-data-modal .extract-head{\n    padding: 20px 17px;\n    display: flex;\n    /* align-items: center; */\n    justify-content: space-between;\n}\n\n.extract-data-modal .extract-head .xclose-btn{\n    background-color: transparent;\n    width: 35px;\n    height: 35px;\n    border-radius: 50%;\n    border: none;\n    cursor: pointer;\n    transition: var(--main-transition);\n}\n\n.extract-data-modal .extract-head .xclose-btn:hover{\n    background-color: #EEE;\n}\n\n.extract-data-modal .extract-head .xclose-btn svg{\n    color: var(--gray-color);\n    font-size: 18px;\n}\n\n\n.extract-data-modal .table{\n    background-color: white;\n    padding: 10px;\n\n}\n\n.extract-data-modal .table .row-head{\n    background-color: white;\n    border: 1px solid #EEE;\n    height: 40px;\n    border-radius: 8px;\n    display: flex;\n    justify-content: space-around;\n}\n\n.extract-data-modal .table .row{\n    background-color: white;\n    border: 1px solid #EEE;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    margin-top: 5px;\n    height: 45px;\n}\n\n.extract-data-modal .table .table-body{\n    margin-top: 8px;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
